import { SyntheticEvent, useCallback } from "react";

import { useCartActions } from "../../../contexts/CartServiceContext/CartServiceContext";
import { useConfigContext } from "../../../contexts/ConfigContext/ConfigContext";
import { CART_LEVEL_TAKEAWAY_BYOB_FEE } from "../../constants";

export const useTakeawayItemByob = () => {
	const actions = useCartActions();
	const { state: takeaway_fee } = useConfigContext((state) => state.config.takeaway_fee);

	return useCallback(
		(evt: SyntheticEvent, byob: boolean) => {
			evt.stopPropagation();
			const fee: number = byob ? CART_LEVEL_TAKEAWAY_BYOB_FEE : takeaway_fee;

			actions.TAKEAWAY_BYOB({
				byob,
				fee,
			});
		},
		[actions, takeaway_fee]
	);
};
